import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

export type Lang = "nl" | "en";

interface LanguageCtx {
  lang: Lang;
  setLang: (lang: Lang) => void;
  /** Pick the string for the active language. */
  t: (nl: string, en: string) => string;
}

const Ctx = createContext<LanguageCtx>({ lang: "nl", setLang: () => {}, t: (nl) => nl });

const KEY = "obf_lang";

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => (localStorage.getItem(KEY) as Lang) || "nl");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (next: Lang) => {
    localStorage.setItem(KEY, next);
    setLangState(next);
  };
  const t = (nl: string, en: string) => (lang === "en" ? en : nl);

  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
}

export const useLang = () => useContext(Ctx);
